var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22 12H10a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1V13a1 1 0 00-1-1zm0 13H10V13h12zm-3.024-14h1.07V6.993L22 8.984V7.55L19.5 5 17 7.55v1.434l1.976-1.991zM15 8.449V7.016l-1.968 2.017V5h-1.065v4.008L10 7.016v1.433L12.489 11zm-1.607 8.033a.743.743 0 10-.746-.743.743.743 0 00.746.743zm6.034-.003a.743.743 0 10-.746-.743.743.743 0 00.746.743zM13.507 23a2.507 2.507 0 002.183-1.27l-.287-.601a1.998 1.998 0 11-3.15-2.171v-.614A2.493 2.493 0 0013.508 23zm.621-5.555a.728.728 0 00-1.456 0v1.93a.714.714 0 00.716.713h2.005l.886 1.865a.379.379 0 00.685-.322l-.98-2.066-.002.001a.372.372 0 00-.34-.22h-1.514v-1.022h.79a.26.26 0 10.003-.519h-.793zm3.977 2.41a.25.25 0 00.25-.25v-1.75h.204v4.781a.363.363 0 00.726 0V19.57h.285v3.067a.362.362 0 00.362.362.363.363 0 00.363-.362v-4.782h.205v1.75a.25.25 0 00.5.004v-2.152a.797.797 0 00-.806-.745H18.66a.796.796 0 00-.805.745v2.149a.25.25 0 00.25.25z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 3A13 13 0 113 16 13 13 0 0116 3m0-1a14 14 0 1014 14A14 14 0 0016 2z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--elevator-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'ElevatorCircleIcon';
export default Icon;